
import {Checkbox, FormGroup, Paper, TextField, Typography, FormControlLabel, Button, FormControl, Select, InputLabel, MenuItem, Table, TableCell, TableBody, TableContainer, TableRow, TableHead} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import { useState, useEffect } from "react";
import {getSumByKey, removesalessupport, sortByKey} from "./date";
import DateCalc from "./date";
import { Dialog } from '@mui/material'
import { fetchCustomerbyId, updateCustdata, fetchwadata, fetchLeadbyId, makecall, getloyalty, updateLeaddata, fetchLeadsbyNumber } from "../api/customerapi";
import GetRole from "./user";
import {svtoken} from "../api/customerapi";
import { v4 as uuidv4 } from "uuid";



const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(60),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    headertext: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    bullettext: {
        marginLeft: theme.spacing(2),
        
    },
    text: {
        color: "#ffffff",
        textDecoration: "none"
        
    },
    
    formgroup: {
        justifyContent: "center",   
    },
    textArea: {
        marginLeft: theme.spacing(12),
        marginRight: theme.spacing(14),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
      },
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(4),
        width: theme.spacing(20),
        height: theme.spacing(6),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        
      },
      smallbutton: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(4),
        width: theme.spacing(10),
        height: theme.spacing(4),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        
      },
      smallbutton2: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(4),
        width: theme.spacing(10),
        height: theme.spacing(4),
        
        
      },
      input: {
        "&:invalid": {
          border: "red solid 2px"
        }
      },
      
  }));

const Custdataupdate = () => {

    const classes = useStyles();
    const preURL=document.referrer;
    const currenturl=window.location.href;
    const urlarray=currenturl.split("/");
    const currentid=urlarray[urlarray.length-1];
    const [Attempted, setAttempted] = useState(false);
    const [userdetails, setuserdetails]=useState(false)
    const [emp, setemp]=useState([])
    const [Open5, setOpen5] = useState(false);
    const [loyaltydata, setloyaltydata]=useState([])
    const [triptrue, settriptrue]=useState(false)
    const [emplist, setemplist]=useState([])
    const [Open2, setOpen2]=useState(false)
    const [wadata, setwadata]=useState([{
        wa_name: "",
    wa_owner: "",
    wa_body: "",
    wa_category:"",
    wa_custom: false,
    wa_id:0,
    wa_cust:false,
    wa_trip:false
    }])
    const [custData, setcustData] =useState({
        cust_name: "",
        primary_mobile_number: undefined,
        chat_mobile_number: undefined,
        secondary_mobile_numbers: "",
        only_chat: false,
        super_user: false,
        marketing_message: true,
        cust_ref: "",
        cust_notes: "",
        cust_channel: "",
        primary_email_id: "",
        secondary_email_ids: "",
        cust_city: "",
        cust_state: "",
        cust_model: "",
        cust_createdBy: "",
        cust_trips:[{
        id: undefined,
        status: ""
        }],
    });
    const [leadData, setleadData] =useState({});
    const [followupData, setfollowupData] =useState({
        notes:"",
        status:"Open",
        owner:"",
        roc:""
    });
    const { cuser, role, employeelist, destinationlist, loading } = GetRole();

      const getCustomer = async (id) => {
        try{
        const data = await fetchCustomerbyId(id);
        console.log(data.data)
        setcustData(data.data)
        const urlarray=preURL.split("/");
        //console.log(urlarray)
        if(urlarray.length>=4){
           console.log(data.data.follow_up)
          setfollowupData(data.data.follow_up)  
        }else{
          if(role=="Sales"){
          var tempfup={...data.data.follow_up, status:"Open", owner:"", roc:""}
          setfollowupData(tempfup)
          if(data.data.follow_up.status=="Closed" && data.data.follow_up.owner!==cuser){
          tempfup={...data.data.follow_up, status:"Open", owner:cuser,roc:""}
          const newcustData={...custData, follow_up:tempfup, updatedAt:new Date()}
          const updatecustResponse= await updateCustdata(data.data[0]._id, newcustData);
          }
          }else{
          console.log(data.data.follow_up)
          setfollowupData(data.data.follow_up)  
          }
        }
          const data11=await fetchLeadsbyNumber(data.data.primary_mobile_number)
          //console.log(data11.data)
          if(data11.data.length>0){
            var sortedarr=sortByKey(data11.data,"lead_id")
            var number=sortedarr[sortedarr.length-1].lead_id
            //console.log(number)
            const data3 = await fetchLeadbyId(number);
            console.log(data3.data)
         setleadData(data3.data)
         var r=validatecall(data3.data)
         settriptrue(r)
          }else{
            settriptrue(true)
          }
       
        const data2= await fetchwadata()
        setwadata(data2.data)
    }catch(err){
        console.log(err)
      }
    }
    const getEmployees = async () => {
        try{
       
        setemplist(employeelist)
        const empsplist = employeelist.filter((emp) => emp.role == "Sales" || emp.role=="TL" || emp.role == "SME");
        const temp=employeelist.filter((emp) => emp.short_name == cuser);
        setuserdetails(temp[0])
        //console.log(temp[0])
        const empshortname = empsplist.map((emp) => emp.short_name);
        let sortedemp = empshortname.sort()
        setemp(sortedemp);
        //setemp(empshortname);
    }catch(err){
        console.log(err)
      }
      };

    const validatecall=(leadData)=>{
      //console.log(leadData)
      
      if(leadData){
        if("callrecord" in leadData && leadData.callrecord.length>0){
          var validcallrecord=removesalessupport(leadData.callrecord)
          console.log(validcallrecord)
          if(validcallrecord.length>1){
            return true
          }else if(validcallrecord.length==1 && Number(validcallrecord[0].outbound_sec)>20){
              return true
            }else{
            return false
            }
          
        }else{
          return false
        }
      }else{
        return false
      }
    }
   

    useEffect(() => {
       
       if (!loading) {
      getEmployees()
      getCustomer(currentid)
    }
        
    }, [loading, cuser, role, employeelist, destinationlist])

  //   useEffect(() => {
  //     // getCustomer(currentid)
  //     getEmployees()
  // }, [userdetails])
  //console.log(userdetails)

    var walist=[]
    if(custData.follow_up && custData.follow_up.owner){
        walist=wadata.filter(wa => wa.wa_cust==true && (wa.wa_custom == false || wa.wa_owner == custData.follow_up.owner))
    } else{
        walist=wadata.filter(wa => wa.wa_cust==true && (wa.wa_custom == false))
    }
    //console.log(walist)

    const whatsapp=(name)=>{
        if (custData.chat_mobile_number){
        var body=walist.filter(wa => wa.wa_name==name)
       var text5="";
        var text2=body[0].wa_body
        if(custData.follow_up && custData.follow_up.time && custData.follow_up.date){
            text5=text2.replace("<time>",custData.follow_up.time+" on "+custData.follow_up.date)
        } else{
            text5=text2
        }
        var text4=text5.replace("<name>",custData.cust_name)
        var text3=text4.split("||")
        //console.log(text3)
        var text=""
        for (var i=0;i<text3.length;i++){
            if(i==0){
                text=text3[i]
            }else{
                text=text+"%0a"+text3[i]
            }
        }
        var win=window.open(`https://wa.me/91${custData.chat_mobile_number}?text=${text}`, '_blank');
    }else{
            alert("Chat mobile number not present. Please enter number and try again")
        }
        // var win2 = window.open(`https://wa.me/91${num}?text=${text}`);
        // //setTimeout(win2.close(),5000)
        // win2.close()
        
    }
    
    
      const custom=()=>{
    if (custData.chat_mobile_number){
    var customtext=prompt("Enter custom message: (use || for new line)")
    if(customtext){
    var text3=customtext.split("||")
    console.log(text3)
    var text=""
    for (var i=0;i<text3.length;i++){
        if(i==0){
            text=text3[i]
        }else{
            text=text+"%0a"+text3[i]
        }
    }
    var win=window.open(`https://wa.me/91${custData.chat_mobile_number}?text=${text}`, '_blank');
}else{
    alert("No text present")
}
}else{
    alert("Chat mobile number not present. Please enter number and try again")
}
      }

    const dialogopen = async() => {
        setOpen2(true);
        
        //console.log(quotelist)
      };
    
      const handleClose = () => {
        setOpen2(false);
      };
      console.log(leadData)

    const handleSubmit = async(e) => {
        try{
          let flag=0
        e.preventDefault();
        if(custData.cust_trips.length==0 && followupData.status=="Closed"){
          alert("No trips found. Please recheck before closing")
          if("roc" in followupData && followupData.roc !==""){

          }else{
            alert("Cannot close follow up. No trips found and no reason found for closing")
            flag=1
          }
        }
         if(followupData.owner=="" && followupData.status=="Closed"){
          alert("Cannot close follow up. No cust owner found")
            flag=1
         }
         if(!(leadData.lead_owner =="Abhishek" || leadData.lead_owner =="RohitS")){
         if(role=="Sales" && (cuser !==leadData.lead_owner)){
          alert("Cannot assign customer to any other sales person. Must be assigned to: "+leadData.lead_owner)
          flag=1
         }
        }
        if(!flag){
        const newcustData={...custData, follow_up:followupData, updatedAt:new Date(), loyalty_wallet:loyaltydata, updated_by:cuser}
        const updatecustResponse= await updateCustdata(custData._id, newcustData);
       
        if(updatecustResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
            alert("Data updated for customer with cust id "+updatecustResponse.data.cust_id);
            window.location = ("/custdataentry/"+updatecustResponse.data.cust_id);
        }
        else{
            alert("Something went wrong. Contact support");
            window.location = ("/");
        }
      }
    }catch(err){
        console.log(err)
      } 
       
    }

    const apicall=async()=>{
        const emp=emplist.filter(e=> e.short_name==cuser && e.role !=="Ex-employee")
        console.log(emp)
        if(custData.primary_mobile_number && emp[0].contact){
        const calldata={
          emp_number:String(emp[0].contact),
          cust_number:String(custData.primary_mobile_number),
          token:svtoken,
          entity_type:"Lead",
          entity_id:leadData.lead_id,
        }
       // console.log(calldata)
        try{
        const responsedata=await makecall(calldata)
        if(responsedata.data.message=="Originate successfully queued"){
          setAttempted(true)
          //window.location.reload()
        }
        //console.log(responsedata.data)
        alert(responsedata.data.message)
        }catch(error){
          console.log(error)
          setAttempted(true)
          alert("Error. Call manually")
        }
      }else{
        alert("Try again")
      }
      }

      const addentry=() => {
        setloyaltydata([...loyaltydata,{id:uuidv4()}])
      }

      const removeentry=() => {
        setloyaltydata(loyaltydata.slice(0,loyaltydata.length-1))
      }

      const loyalty=async()=>{
       try{ 
        if(loyaltydata.length>0){

        }else{
        const data=await getloyalty(custData.cust_id)
        console.log(data.data)
        setloyaltydata(data.data[0].loyalty_wallet)
        }
        setOpen5(true)
      }catch(error){
        console.log(error)
      }
      }

      const handleClose5 = () => {
        setOpen5(false);
      };

      const skipcall=async()=>{
        try{
        
          const newleadData={...leadData, skip_second_call:true}
          const updateleadResponse= await updateLeaddata(leadData._id, newleadData);
          settriptrue(true)
        }catch(err){
          console.log(err)
        }
      }
  //<a href="tel:+919654426684">Call</a>

    //()=>custData.primary_mobile_number === undefined ? 1 : custData.primary_mobile_number
    //console.log(followupData)

    return (  
      <div>{role && cuser?(
        <Paper variant="outlined" className={classes.paper} elevation={10}>
         <Dialog
          fullWidth
        maxWidth="xl"
        open={Open5}
        onClose={handleClose5}
         >
          <Typography variant="h4" align="center" className={classes.headertext}>Loyalty Point: {loyaltydata.length>0?getSumByKey(loyaltydata, "transaction_value"):0}</Typography>
         {loyaltydata.length>0 && loyaltydata.map(ld=>{return (
          <div>
           
          
              <FormGroup row className={classes.formgroup}>
               <TextField
                                  variant="standard"
                                  required
                                  label="Date"
                                  id={loyaltydata.indexOf(ld)}
                                  type="date"
                                  InputLabelProps={{ shrink: true }}
                                  value={
                                    ld.transaction_date === undefined
                                      ? ""
                                      : ld.transaction_date.split("T").slice(0, 1)
                                  }
                                  className={classes.textField}
                                  onChange={(e) => setloyaltydata(loyaltydata.map(l=>loyaltydata.indexOf(l)==loyaltydata.indexOf(ld)?{...ld, transaction_date:e.target.value}:l))}
                                />
              <TextField variant="standard"  label="Notes"  value={ld.transaction_note}  InputLabelProps={{ shrink: true }} className={classes.textField} onChange={(e) => setloyaltydata(loyaltydata.map(l=>loyaltydata.indexOf(l)==loyaltydata.indexOf(ld)?{...ld, transaction_note:e.target.value}:l))}/>
              <TextField variant="standard"  label="Amount"  value={ld.transaction_value}  InputLabelProps={{ shrink: true }} className={classes.textField} onChange={(e) => setloyaltydata(loyaltydata.map(l=>loyaltydata.indexOf(l)==loyaltydata.indexOf(ld)?{...ld, transaction_value:e.target.value}:l))}/>
              </FormGroup>
              
          </div>
         )})}
          <FormGroup row className={classes.formgroup}>
            <Button
              variant="outlined"
              color="primary"
              className={classes.button}
              onClick={()=>addentry()}
            >
              {" "}
              + Tranche
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              className={classes.button}
              onClick={()=>removeentry()}
            >
              {" "}
              - Tranche
            </Button>
          </FormGroup>
          <Typography variant="h4" align="center" className={classes.headertext}>Terms & Conditions</Typography>
          <Typography variant="h6" className={classes.bullettext}>Accumulation of Points</Typography>
          <ul>
          <li><p className={classes.bullettext}>Points can be obtained by different activities or schemes run from time to time by Jeto Vacations</p></li>
          <li><p className={classes.bullettext}>Final decision on addition of points rely solely on the discretion of Jeto Vacations</p></li>
          </ul>
          <br></br>
          <Typography variant="h6" className={classes.bullettext}>Redemption of Points</Typography>
         
          <ul>
          <li><p className={classes.bullettext}>1 point is equivalent to 1 rupee</p></li>
          <li><p className={classes.bullettext}>Points can be converted into discounts while booking a vacation package. Points cannot be redeemed on booking only flights, only hotels or visa</p></li>
          <li><p className={classes.bullettext}>A maximum of 1000 points per person can be redeemed for domestic vacation and 2000 points per person on international vacation</p></li>
          <li><p className={classes.bullettext}>Loyalty point discounts cannot be clubbed with any other discounts or coupon codes</p></li>
          <li><p className={classes.bullettext}>Final decision on redemption of points rely solely on the discretion of Jeto Vacations</p></li>
          </ul>
         </Dialog>
        <div align="right" >
        <Button onClick={dialogopen} variant="contained"  color="primary" className={classes.smallbutton}><h6>Whatsapp</h6></Button>
        <Button onClick={apicall} variant="contained"  color="secondary" align="right" className={classes.smallbutton}><h6>Call</h6></Button>
        <Button onClick={loyalty} variant="contained"  color="secondary" align="right" className={classes.smallbutton}><h6>Loyalty</h6></Button>
        </div>
        
            <Typography variant="h4" align="center" className={classes.headertext}> Update Customer (Customer ID:{custData.cust_id} Created At:{new Date(custData.createdAt).toLocaleString("en-IN")})</Typography>
            <a href={"/lead/"+custData.lead_id}><Typography variant="h4" align="center" className={classes.headertext}>(Lead Id:{custData.lead_id})</Typography></a>
            <Typography variant="h6" align="center" className={classes.headertext}> All trips: {custData.cust_trips.map(trip => trip.id !==undefined ? (trip.id + " || ") : "")} </Typography>
            <div align="center">
            {custData.cust_trips?.map(trip => {
                return <a  href={"/tripdataentry/"+trip.id}>{trip.id+" || "}</a>
            })}</div>
            <form onSubmit={handleSubmit}>
            
            <FormGroup row className={classes.formgroup}>
                <TextField variant="standard"  label="Name"  value={custData.cust_name}  InputLabelProps={{ shrink: true }} className={classes.textField} onChange={(e)=> setcustData({...custData, cust_name: e.target.value})}/>
                {role=="Product" || role=="TL" || role=="Manager" || role=="Marketing" || role=="Admin"?(
                  <div>
                <TextField variant="standard" required  label="Primary Mobile Number (number)"  value={role=="Admin" || role=="TL" || role=="Manager" || role=="Accounts"?custData.primary_mobile_number:"**********"} inputProps={{className: classes.input, pattern:"[0-9]{8,14}"}} InputLabelProps={{ shrink: true }} className={classes.textField} onChange={(e)=> setcustData({...custData, primary_mobile_number: e.target.value})}/>
                <TextField variant="standard"  label="Chat Number (number)"  inputProps={{className: classes.input, pattern:"[0-9]{8,14}"}} value={custData.chat_mobile_number}  InputLabelProps={{ shrink: true }} className={classes.textField} onChange={(e)=> setcustData({...custData, chat_mobile_number: e.target.value})}/>
                </div>
                ):(<div>
                  {Attempted?(
                    <div>
                <TextField variant="standard" required  label="Primary Mobile Number (number)"  value={role=="Admin" || role=="TL" || role=="Manager" || role=="Accounts" || (cuser && "owner" in followupData && cuser==followupData.owner)?custData.primary_mobile_number:"**********"} inputProps={{className: classes.input, pattern:"[0-9]{8,14}"}} InputLabelProps={{ shrink: true }} className={classes.textField} onChange={(e)=> setcustData({...custData, primary_mobile_number: e.target.value})}/>
                <TextField variant="standard"  label="Chat Number (number)"  inputProps={{className: classes.input, pattern:"[0-9]{8,14}"}} value={custData.chat_mobile_number}  InputLabelProps={{ shrink: true }} className={classes.textField} onChange={(e)=> setcustData({...custData, chat_mobile_number: e.target.value})}/>
                </div>
                  ):(
                    <div>
                    {userdetails && "permissions" in userdetails && "show_number" in userdetails.permissions && userdetails.permissions.show_number?(
                      <Button onClick={()=>setAttempted(true)} variant="contained"  color="save" className={classes.button}>Edit Number</Button>
                    ):(
                      ""
                    )}
                    </div>
                  )}
                  </div>
          )}
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
                <TextField variant="standard"  label="Primary Email Id"  value={custData.primary_email_id} InputLabelProps={{ shrink: true }} className={classes.textField} onChange={(e)=> setcustData({...custData, primary_email_id: e.target.value})}/>
                <TextField variant="standard"  label="Secondary Email Ids"  value={custData.secondary_email_ids} InputLabelProps={{ shrink: true }} className={classes.textField} onChange={(e)=> setcustData({...custData, secondary_email_ids: e.target.value})}/>
                {userdetails && userdetails.permissions.show_number?(
                <TextField variant="standard" label="Secondary Mobile Numbers"   value={custData.secondary_mobile_numbers}  InputLabelProps={{ shrink: true }} className={classes.textField} onChange={(e)=> setcustData({...custData, secondary_mobile_numbers: e.target.value})}/>
                ):("")}
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
                <FormControlLabel control={<Checkbox color="primary"/>}  checked={custData.only_chat} label="Only Chat" onChange={(e)=> setcustData({...custData, only_chat: e.target.checked})}/>
                <FormControlLabel control={<Checkbox color="primary" defaultChecked />}  checked={custData.marketing_message} label="Send Marketing messages"  onChange={(e)=> setcustData({...custData, marketing_message: e.target.checked})}/>
                <FormControlLabel control={<Checkbox color="primary"/>}  checked={custData.super_user} label="Super User" onChange={(e)=> setcustData({...custData, super_user: e.target.checked})}/>
                <TextField variant="standard"  label="Referred by cust id"  value={custData.referred_by_cust} InputLabelProps={{ shrink: true }} className={classes.textField} onChange={(e)=> setcustData({...custData, referred_by_cust: e.target.value})}/>
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
                <TextField variant="standard"  label="City"  value={custData.cust_city} InputLabelProps={{ shrink: true }} className={classes.textField} onChange={(e)=> setcustData({...custData, cust_city: e.target.value})}/>
                <FormControl
                style={{
                  minWidth: 480,
                  marginTop: 16,
                  marginRight: 64,
                  marginLeft: 8,
                }}
              >
                <InputLabel id="State">State</InputLabel>
                <Select
                  classname={classes.textField}
                  
                  labelId="State"
                  value={custData.cust_state ? custData.cust_state : ""}
                  onChange={(e) =>
                    setcustData({ ...custData, cust_state: e.target.value })
                  }
                >
                  <MenuItem value={"Andaman & Nicober Islands"}>
                    Andaman & Nicober Islands
                  </MenuItem>
                  <MenuItem value={"New Delhi"}>New Delhi</MenuItem>
                  <MenuItem value={"Karnataka"}>Karnataka</MenuItem>
                  <MenuItem value={"Telengana"}>Telengana</MenuItem>
                  <MenuItem value={"Andhra Pradesh"}>Andhra Pradesh</MenuItem>
                  <MenuItem value={"Manipur"}>Manipur</MenuItem>
                  <MenuItem value={"Maharashtra"}>Maharashtra</MenuItem>
                  <MenuItem value={"Goa"}>Goa</MenuItem>
                  <MenuItem value={"Odisha"}>Odisha</MenuItem>
                  <MenuItem value={"West Bengal"}>West Bengal</MenuItem>
                  <MenuItem value={"Gujarat"}>Gujarat</MenuItem>
                  <MenuItem value={"Assam"}>Assam</MenuItem>
                  <MenuItem value={"Haryana"}>Haryana</MenuItem>
                  <MenuItem value={"Punjab"}>Punjab</MenuItem>
                  <MenuItem value={"Chandigarh"}>Chandigarh</MenuItem>
                  <MenuItem value={"Himachal Pradesh"}>
                    Himachal Pradesh
                  </MenuItem>
                  <MenuItem value={"Uttar Pradesh"}>Uttar Pradesh</MenuItem>
                  <MenuItem value={"Sikkim"}>Sikkim</MenuItem>
                  <MenuItem value={"Rajasthan"}>Rajasthan</MenuItem>
                  <MenuItem value={"Jammu & Kashmir"}>Jammu & Kashmir</MenuItem>
                  <MenuItem value={"Madhya Pradesh"}>Madhya Pradesh</MenuItem>
                  <MenuItem value={"Chattisgarh"}>Chattisgarh</MenuItem>
                  <MenuItem value={"Bihar"}>Bihar</MenuItem>
                  <MenuItem value={"Jharkhand"}>Jharkhand</MenuItem>
                  <MenuItem value={"Nagaland"}>Nagaland</MenuItem>
                  <MenuItem value={"Tripura"}>Tripura</MenuItem>
                  <MenuItem value={"Mizoram"}>Mizoram</MenuItem>
                  <MenuItem value={"Meghalaya"}>Meghalaya</MenuItem>
                  <MenuItem value={"Arunachal Pradesh"}>
                    Arunachal Pradesh
                  </MenuItem>
                  <MenuItem value={"Tamil Nadu"}>Tamil Nadu</MenuItem>
                  <MenuItem value={"Kerala"}>Kerala</MenuItem>
                  <MenuItem value={"Ladakh"}>Ladakh</MenuItem>
                </Select>
              </FormControl>
                <TextField variant="standard"  label="Referred customer ids"   value={custData.cust_ref} InputLabelProps={{ shrink: true }} className={classes.textField} onChange={(e)=> setcustData({...custData, cust_ref: e.target.value})}/>
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  type="date" label="Date of birth"   value={("cust_dob" in custData && custData.cust_dob)? custData.cust_dob.split("T").slice(0,1):""} InputLabelProps={{ shrink: true }} className={classes.textField}  onChange={(e)=> setcustData({...custData, cust_dob: e.target.value})}/>
                <TextField variant="outlined"  type="date" label="Anniversary"  value={"cust_anniversary" in custData && custData.cust_anniversary?custData.cust_anniversary.split("T").slice(0,1):""} InputLabelProps={{ shrink: true }} className={classes.textField}  onChange={(e)=> setcustData({...custData, cust_anniversary: e.target.value})}/>
                <FormControl style={{minWidth: 450, marginTop: 16, marginRight: 24, marginLeft: 5}}>
            <InputLabel id="model">Customer Model </InputLabel>
                <Select required className={classes.textField} labelId="model" value={custData.cust_model} onChange={(e)=> setcustData({...custData, cust_model: e.target.value})}>
                    <MenuItem value={"B2C"}>B2C</MenuItem>
                    <MenuItem value={"B2B"}>B2B</MenuItem>
                  
                
                </Select>
                </FormControl>
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  label="Notes"  value={custData.cust_notes} InputLabelProps={{ shrink: true }} className={classes.textArea} fullWidth multiline rows={4} onChange={(e)=> setcustData({...custData, cust_notes: e.target.value})}/>
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  label="Demographic"  placeholder="City, Profession, Relation with fellow travellers, kids age" value={custData.cust_demo} InputLabelProps={{ shrink: true }} className={classes.textArea} fullWidth multiline rows={4} onChange={(e)=> setcustData({...custData, cust_demo: e.target.value})}/>
            </FormGroup>

            <FormGroup row className={classes.formgroup}>
                <TextField variant="outlined"  label="Travel History" placeholder="Places already travelled, how did they book those trip" value={custData.cust_travel_history} InputLabelProps={{ shrink: true }} className={classes.textArea} fullWidth multiline rows={4} onChange={(e)=> setcustData({...custData, cust_travel_history: e.target.value})}/>
            </FormGroup>
                  <br></br>
              <Typography variant="h5" align="center" className={classes.headertext}> Follow Up (Updated At:{followupData && "updatedAt" in followupData?new Date(followupData.updatedAt).toLocaleString():""} ) by {followupData && "updated_by" in followupData?(followupData.updated_by):""}</Typography>
            <FormGroup row className={classes.formgroup}>
            {role && role!=="Sales"?(
              <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="status">Followup Status</InputLabel>
                <Select className={classes.textField} labelId="status" value={followupData === undefined ? "" : followupData.status} onChange={(e)=> setfollowupData({...followupData, status: e.target.value, updatedAt:new Date(), updated_by:cuser})}>
                    <MenuItem value={"Open"}>Open</MenuItem>
                    <MenuItem value={"Closed"}>Closed</MenuItem>  
                
                </Select>
                </FormControl>
            ):(
              <FormControl style={{minWidth: 480, marginTop: 16, marginRight: 32, marginLeft: 8}}>
            <InputLabel id="status">Followup Status</InputLabel>
                <Select className={classes.textField} labelId="status" value={followupData === undefined ? "" : followupData.status} onChange={(e)=> setfollowupData({...followupData, status: e.target.value, updatedAt:new Date(), updated_by:cuser})}>
                    <MenuItem value={"Open"}>Open</MenuItem>
                    
                
                </Select>
                </FormControl>
            )}
            
                  {role && !(role=="Sales" || role=="TL")?(
                <FormControl style={{minWidth: 450, marginTop: 16, marginRight: 24, marginLeft: 5}}>
            <InputLabel id="owner">Owner</InputLabel>
                <Select className={classes.textField} labelId="Owner" value={followupData === undefined? "" :followupData.owner} onChange={(e)=> setfollowupData({...followupData, owner: e.target.value, updatedAt:new Date(), updated_by:cuser})}>
                
                {emp.map((e) => {
                return <MenuItem value={e}>{e}</MenuItem>;
              })}
                  {/* <MenuItem value={leadData.lead_owner}>{leadData.lead_owner}</MenuItem>   */}
                
                </Select>
                </FormControl>
              ):(
                <FormControl style={{minWidth: 450, marginTop: 16, marginRight: 24, marginLeft: 5}}>
            <InputLabel id="owner">Owner</InputLabel>
                <Select className={classes.textField} labelId="Owner" value={followupData === undefined? "" :followupData.owner} onChange={(e)=> setfollowupData({...followupData, owner: e.target.value, updatedAt:new Date(), updated_by:cuser})}>
                <MenuItem value={cuser}>{cuser}</MenuItem>
                
                    
                
                </Select>
                </FormControl>
              )}
                <FormControl style={{minWidth: 450, marginTop: 16, marginRight: 24, marginLeft: 5}}>
                <InputLabel id="roc">Cancellation Reason</InputLabel>
                <Select displayEmpty className={classes.textField} labelId="roc" value={followupData === undefined? "" :followupData.roc} onChange={(e)=> setfollowupData({...followupData, roc: e.target.value, updatedAt:new Date(), updated_by:cuser})}>
                    <MenuItem value={"No response"}>No response</MenuItem>
                    <MenuItem value={"Destination not served"}>Destination not served</MenuItem>
                    <MenuItem value={"Product not served"}>Product not served</MenuItem>
                    <MenuItem value={"Already Booked"}>Already Booked</MenuItem>
                    <MenuItem value={"Denied placing lead"}>Denied placing lead</MenuItem>
                    <MenuItem value={"Looking for group tours"}>Looking for group tours</MenuItem>
                    <MenuItem value={"Plan cancelled"}>Plan cancelled</MenuItem>
                    <MenuItem value={"Budget mismatch"}>Budget mismatch</MenuItem>
                    <MenuItem value={"Misunderstood ad"}>Misunderstood ad</MenuItem>
                    <MenuItem value={"Wants group trip"}>Wants group trip</MenuItem>
                    <MenuItem value={"Others"}>Others</MenuItem>
                
                </Select>
                </FormControl>

                      
                <TextField variant="standard"  type="date" label="Followup Date"  value={followupData === undefined? "" :followupData.date} className={classes.textField} InputLabelProps={{ shrink: true }} onChange={(e)=> setfollowupData({...followupData, date: e.target.value})}/>
                <TextField variant="standard"  type="time" label="Followup Time"  value={followupData === undefined? "" : followupData.time} className={classes.textField} InputLabelProps={{ shrink: true }} onChange={(e)=> setfollowupData({...followupData, time: e.target.value})} />
                <TextField variant="standard"  label="Followup Notes"  value={followupData === undefined? "" : followupData.notes} className={classes.textField} onChange={(e)=> setfollowupData({...followupData, notes: e.target.value})}/>
            </FormGroup>
            <Typography variant="h4" align="center" className={classes.headertext}> If you are changing primary mobile number, please update all associated trips ids as well</Typography>
              
            <FormGroup row className={classes.formgroup}>
                <Button variant="contained" color="primary" type="submit" className={classes.button}>Save</Button>
                <Button href="/home" variant="contained" color="secondary" className={classes.button}>Cancel</Button>
                {/* <Button href="/tripdataentry" variant="contained"  color="save" className={classes.button}>Create Trip</Button> */}
                {triptrue?(
                <Button href="/leadtripdataentry" variant="contained"  color="save" className={classes.button}>Create Trip-Lead</Button>
                ):(<Button onClick={()=>skipcall()} variant="contained" className={classes.button}>Skip Call</Button>)}
            </FormGroup>
              
            </form>

            <Dialog fullWidth maxWidth="sm" open={Open2} onClose={handleClose}>
           
            <a href="https://docs.google.com/spreadsheets/d/1D7huwcWGlh0prUBXL4KVYlxd5wpo3IKvQvuq7F__mVg/edit#gid=0" rel="noopener noreferrer" target="_blank" variant="h6" align="center" className={classes.headertext}> Doc Link for detailed messages</a>
            <TableContainer>
                <Table >
                    <TableHead>
                        <TableRow>
                            <TableCell style={{ width: 420 }}  align="center">Message Name - Message Category <Button  onClick={custom} variant="outlined" color="secondary" className={classes.smallbutton2}>Custom</Button></TableCell>
                            
                        </TableRow>
                    </TableHead>
                    <TableBody>
                    {walist?.map(wa => {
                return <div>
                    <TableRow key={wa.wa_id} align="center" >
                        <TableCell  style={{ width: 420 , height:10}} align="center">{wa.wa_name} - {wa.wa_category} <Button  onClick={()=>whatsapp(wa.wa_name)} variant="outlined" color="primary" className={classes.smallbutton2}>Send</Button></TableCell>
                        
                    </TableRow>
                    
                    
                    </div>
            })}
                    </TableBody>
                </Table>
            </TableContainer>          
            </Dialog>
            
        </Paper>
        ):("")}</div>
    );
}

export default Custdataupdate;